import gql from "graphql-tag";

export const DOCUMENT_TEMPLATES = gql`
  query DocumentTemplates(
    $skip: Int
    $take: Int
    $where: DocumentTemplateWhereInput
    $orderBy: [DocumentTemplateWhereInput]
  ) {
    documentTemplates(
      skip: $skip
      take: $take
      where: $where
      orderBy: $orderBy
    ) {
      data {
        id
        name
        s3Key
        status
        createdDate
        hasUnpublishedChanges
        publishedAt
        usages {
          insurancePlanId
          insurancePlanName
          type
          area
          outputName
          conditions
        }
      }
      count
    }
  }
`;

export const DOCUMENT_TEMPLATE = gql`
  query DocumentTemplate($where: DocumentTemplateWhereInput) {
    documentTemplate(where: $where) {
      id
      name
      s3Key
      status
      anchors
      anchorMappings
      createdDate
      hasUnpublishedChanges
      publishedAt
      usages {
        insurancePlanId
        insurancePlanName
        type
        area
        outputName
        conditions
      }
    }
  }
`;

export const DOCUMENT_TEMPLATE_DRAFT = gql`
  query DocumentTemplateDraft($where: DocumentTemplateWhereInput!) {
    documentTemplateDraft(where: $where) {
      revision
      content
      updatedDate
    }
  }
`;

export const DOCUMENT_TEMPLATE_VERSIONS = gql`
  query DocumentTemplateVersions($where: DocumentTemplateWhereInput!) {
    documentTemplateVersions(where: $where) {
      id
      versionNumber
      publishedAt
      publishedByName
    }
  }
`;

export const DOCUMENT_TEMPLATE_FILE = gql`
  query DocumentTemplateFile($where: DocumentTemplateWhereInput!) {
    documentTemplateFile(where: $where)
  }
`;

export const DOCUMENT_TEMPLATE_SOURCE = gql`
  query DocumentTemplateSource($where: DocumentTemplateWhereInput!) {
    documentTemplateSource(where: $where) {
      base64
      name
      contentType
      pending
    }
  }
`;

export const DOCUMENT_TEMPLATE_PROPOSALS_JOB = gql`
  query DocumentTemplateProposalsJob(
    $where: DocumentTemplateProposalsJobWhereInput!
  ) {
    documentTemplateProposalsJob(where: $where) {
      id
      status
      proposals {
        zone
        path
        reason
      }
      error
    }
  }
`;

export const DOCUMENT_PAYLOAD_SCHEMA = gql`
  query DocumentPayloadSchema(
    $where: SubscriptionWhereInput
    $quote: DocumentPayloadQuoteInput
  ) {
    documentPayloadSchema(where: $where, quote: $quote) {
      version
      paths {
        path
        type
        sample
      }
      payload
    }
  }
`;

const documentTemplates = {
  DOCUMENT_TEMPLATES,
  DOCUMENT_TEMPLATE,
  DOCUMENT_TEMPLATE_DRAFT,
  DOCUMENT_TEMPLATE_VERSIONS,
  DOCUMENT_TEMPLATE_FILE,
  DOCUMENT_TEMPLATE_SOURCE,
  DOCUMENT_TEMPLATE_PROPOSALS_JOB,
  DOCUMENT_PAYLOAD_SCHEMA,
};

export default documentTemplates;
